import React from 'react'
import { withIcon } from '../../withIcon'

function SendIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M20.4419 3.55808C20.6133 3.72942 20.6702 3.98438 20.5878 4.2123L14.0879 22.2123C14.082 22.2286 14.0754 22.2446 14.0682 22.2604C13.9745 22.4649 13.824 22.6383 13.6346 22.7598C13.4453 22.8813 13.225 22.9459 13 22.9459C12.775 22.9459 12.5548 22.8813 12.3654 22.7598C12.1796 22.6405 12.0312 22.4714 11.9371 22.2718L8.53415 15.4659L1.7282 12.0629C1.52864 11.9688 1.3595 11.8204 1.24025 11.6346C1.11874 11.4453 1.05414 11.225 1.05414 11C1.05414 10.775 1.11874 10.5548 1.24025 10.3654C1.36177 10.1761 1.5351 10.0256 1.73964 9.93184C1.75539 9.92462 1.77143 9.91806 1.78773 9.91217L19.7877 3.41217C20.0156 3.32987 20.2706 3.38673 20.4419 3.55808ZM9.76048 15.1234L12.9878 21.5782L18.4603 6.42358L9.76048 15.1234ZM17.5764 5.5397L2.42187 11.0122L8.87659 14.2395L17.5764 5.5397Z" fill={color}/>
    </svg>
  )
}

export default withIcon(SendIcon)
